import { type VoidFunctionComponent } from 'react';

import CallToAction from '../CallToAction';
import Flex from '../generic/Flex';
import PageHeadingBreadcrumbs from '../generic/PageHeadingBreadcrumbs';
import Text from '../generic/Text';
import TeamSelectionMenu from '../shared/teams/TeamSelectionMenu';
import type { BreadCrumb } from '../generic/PageHeadingBreadcrumbs/Crumb';

import PackageCount from './PackageCount';

//  Note: we store these outside the component so they aren't redeclared on every render
const breadcrumbs: BreadCrumb[] = [
  {
    text: 'Packages',
  },
  {
    //  This component manages its own state, so we can essentially treat it as static JSX here
    content: <TeamSelectionMenu />,
  },
];

/**
 * PackageInventoryCTA is a call-to-action for the
 * Package inventory page.
 *
 * Note that this only accounts for the first page
 * and not the PackageVersion page.
 */
const PackageInventoryCTA: VoidFunctionComponent = () => (
  <CallToAction>
    <Flex align="center" justify="space-between">
      <div>
        <PageHeadingBreadcrumbs crumbs={breadcrumbs} />
        <Text.Text>View all packages used across your organization.</Text.Text>
      </div>
      <PackageCount />
    </Flex>
  </CallToAction>
);

export default PackageInventoryCTA;
